lmApp
  .controller('PermissionsController', ['$scope', '$rootScope', '$templateCache', '$compile', '$timeout', 'AdministrationService', 'ModalWindowService', 'ToastService', 'ValidatorService', 'ApiService', 'ManagerResource',
    function ($scope, $rootScope, $templateCache, $compile, $timeout, AdministrationService, ModalWindowService, ToastService, ValidatorService, ApiService, ManagerResource) {
      $scope.loading = false;

      $scope.getManagers = function () {
          ManagerResource.get().$promise
              .then(function (result) {
                  $scope.managers = result.filter(function (account) {
                      return _.indexOf(account.groups, 'admin') >= 0;
                  });
                  angular.forEach($scope.managers, function (manager) {
                      if (manager.username === $rootScope.globals.currentUser.username) {
                          manager._isCurrentAdmin = true;
                      }
                  });
              })
              .catch(function (reason) {
                  $rootScope.debugInfo(reason, 'silent');
              });
      };
      $scope.getManagers();

      if ($rootScope._self) {
        $scope.getManagers();
        $scope.accountsCollection = $rootScope._self.accounts
          .filter(function (account) {
            return account.groups;
          })
          .filter(function (account) {
            return _.indexOf(account.groups, 'admin') === -1;
          })
          .map(function (account) {
            account._permissions = {};
            account._permissions = AdministrationService.ParseAccountPermissions(account.groups, true);
            return account;
          });
      } else {
        $scope.loading = true;
      }

      var _onSelfUpdate = $scope.$on('self:update', function (event, data) {
        $scope.accountsCollection = data.accounts
          .filter(function (account) {
              return account.groups;
          })
          .filter(function (account) {
            return _.indexOf(account.groups, 'admin') === -1;
          })
          .map(function (account) {
            account._permissions = {};
            account._permissions = angular.copy(AdministrationService.ParseAccountPermissions(account.groups, true));
            return account;
          });
        $scope.loading = false;
      });

      $scope.toggleAccount = function (account) {
        account.isExpand = !account.isExpand;
      };

      $scope.setPermission = function (section, value) {
        section.mode = value;
      };

      $scope.savePermissions = function (account) {
        account.groups = [];

        _.forEach(account._permissions, function (section, permission1) {
          if (!section.sections) {
            if (section.mode !== 'none') account.groups.push(permission1 + '=' + section.mode);
          } else {
            _.forEach(section.sections, function (subsection, permission2) {
              if (subsection.mode !== 'none') account.groups.push(permission1 + ':' + permission2 + '=' + subsection.mode);
            });
          }
        });

        AdministrationService.SetAccountGroups(account)
          .then(function (response) {
            $scope.loading = false;

            ToastService.Small({
              color: 'green',
              title: 'Permissions successfully saved',
              icon: 'account'
            }, 6000);
          })
          .catch(function (reason) {
            $scope.loading = false;

            ToastService.Small({
              color: 'red',
              title: 'Permissions save failed',
              icon: 'account'
            }, 6000);
          });
      };

      $scope.removeAccount = function (account) {

        ModalWindowService.Open({
          content: '<p class="fs-title heavy">Are you sure?</p>' +
          '<br>' +
          'This action will remove account from system permanently.',
          actions: [
            {
              title: 'Do it',
              color: 'green',
              fn: function () {
                AdministrationService.RemoveAccount(account)
                  .then(function (response) {
                    $scope.loading = false;

                    ToastService.Small({
                      color: 'green',
                      title: 'Account successfully removed',
                      icon: 'account'
                    }, 6000);

                    var index = $scope.accountsCollection.indexOf(account);

                    if (index !== -1) {
                      $scope.accountsCollection.splice(index, 1);
                    }
                  })
                  .catch(function (reason) {
                    $scope.loading = false;

                    ToastService.Small({
                      color: 'red',
                      title: 'Account removed failed',
                      icon: 'account'
                    }, 6000);
                  });
              }
            },
            {
              title: 'Cancel',
              color: 'red'
            }
          ],
          keyboard: true
        });
      };

      $scope.createNewAccount = function () {
        $scope._createInner_ = $templateCache.get('add-account.html');
        $scope._createInner_ = $compile($scope._createInner_)($scope);

        $scope.newAccount = {};
        $scope.newAccount = {};
        $scope.newAccount._errors = {};
        $scope.newAccount.groups = ["content:vod=rw"];

        ModalWindowService.Open({
          content: $scope._createInner_,
          actions: [
            {
              title: 'Create',
              color: 'green',
              fn: function () {
                AdministrationService.CreateAccount($scope.newAccount)
                  .then(function (response) {
                    $rootScope.hideLinearProgress('#modalLoader');
                    $scope.loading = false;

                    ToastService.Small({
                      title: 'Account successfully created',
                      color: 'green',
                      icon: 'account'
                    }, 1000 * 3);

                    ApiService.Request('1/self', 'GET')
                      .then(function (response) {
                        $rootScope._self = response.self;

                        $rootScope.$broadcast('self:update', response.self)
                      })
                      .catch(function (reason) {
                        $rootScope._self = {};
                        $rootScope.debugInfo(reason, 'silent');
                      });

                    //response.account._permissions = {};
                    //response.account._permissions = AdministrationService.ParseAccountPermissions(response.account.groups);
                    //$scope.accountsCollection.unshift(response.account);
                  })
                  .catch(function (reason) {
                    ToastService.Small({
                      title: 'Account create failed',
                      color: 'red',
                      icon: 'account'
                    }, 1000 * 3);
                    $rootScope.debugInfo(reason);
                    $rootScope.hideLinearProgress('#modalLoader');
                    $scope.loading = false;
                  });
              },
              check: function () {
                $scope.newAccount._errors = {};

                if (!$scope.newAccount.email) {
                  $scope.newAccount._errors.email = 'Required filed';
                }
                if ($scope.newAccount.email && !ValidatorService.Email($scope.newAccount.email)) {
                  $scope.newAccount._errors.email = 'Wrong email format';
                }
                if (!$scope.newAccount.password) {
                  $scope.newAccount._errors.password = 'Required filed';
                }
                if (!$scope.newAccount.lastName) {
                  $scope.newAccount._errors.lastName = 'Required filed';
                }
                if (!$scope.newAccount.firstName) {
                  $scope.newAccount._errors.firstName = 'Required filed';
                }

                return _.isEmpty($scope.newAccount._errors);
              }
            },
            {
              title: 'Cancel',
              color: 'red'
            }
          ],
          keyboard: true
        });
      };

      $scope.setManagerPassword = function(manager) {
        if ($scope.loading) return;
        $scope.loading = true;
        $rootScope.showLinearProgress('#modalLoader');

        $scope.modalWindowScope = $scope.$new();
        $scope.modalWindowScope.username = manager.username;
        $scope.modalWindowScope.newPassword = '';
        $scope.modalWindowScope.errors = {
          newPassword: ''
        };
        var inner = $compile($templateCache.get('set-subscriber-password.html'))($scope.modalWindowScope);

        ModalWindowService.Open({
          content: inner,
          actions: [
            {
              title: 'I understand. Do it',
              color: 'green',
              check: function () {
                $scope.modalWindowScope.errors.newPassword = '';
                if (!$scope.modalWindowScope.newPassword) {
                  $scope.modalWindowScope.errors.newPassword = 'Password field cannot be empty';
                } else if (!ValidatorService.Password($scope.modalWindowScope.newPassword)) {
                  $scope.modalWindowScope.errors.newPassword = 'Invalid password format. Min 6 symbols. a-z 0-9 _ -.';
                }
                return !$scope.modalWindowScope.errors.newPassword;
              },
              fn: function () {
                ManagerResource.setPassword({id: manager.id, password: $scope.modalWindowScope.newPassword}).$promise
                    .then(function () {
                      $scope.loading = false;
                      $rootScope.hideLinearProgress('#modalLoader');
                      ToastService.Small({
                        title: 'Password successfully changed',
                        color: 'green',
                        icon: 'email-outline'
                      });
                    })
                    .catch(function (reason) {
                      $scope.loading = false;
                      $rootScope.hideLinearProgress('#modalLoader');
                      $rootScope.debugInfo(reason);
                      ToastService.Small({
                        title: 'Failed to set manager password',
                        color: 'red',
                        icon: 'email-outline'
                      });
                    });
              }
            },
            {
              title: 'cancel',
              color: 'red',
              fn: function () {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#modalLoader');
              }
            }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      $scope.$on('$destroy', function () {
        _onSelfUpdate();
      });
    }]);
